module.exports = __webpack_public_path__ + "img/settings.20b56056.svg";